<template>
    <div class="ApplicantDetails q-px-md ">
        <q-card flat style="border:1px solid #A6A6A6;border-radius:25px;">
            <div class="row justify-center text-center">
                <div class="col text-h6">
                    This Transaction Requires TAC
                </div>
            </div>
                <div class="row">
                    <div class="col-3 text-right">
                        <div key="brandimage" class="text-center q-pa-md">
                                <img src="@/assets/tac.png" width="120px" height="120px">
                            </div>
                    </div>
                    <div class="col text-left">
                        <div class="row">
                            <div class="col">
                                <div class="g_header">You Are Almost there!</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="g_text">Please confirm your mobile number by entering the TAC code we've just sent to your mobile device</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="g_text">If you did not receive the TAC code in the next 2 minutes, please click <a class="text-primary">‘Resend TAC’</a> for a new TAC code</div>
                            </div>
                        </div>

                    </div>
                </div>
                <!-- <q-separator color="grey-7"/> 
                , availableTrial >= 3 || 'Balance Trial :' + availableTrial-->
                <div class="row justify-end q-pt-md q-pr-lg">
                    <div class="col-4">
                        <q-input type="password" v-model="StoreStateAD.TAC_code" class="" filled  :rules="[val => !!val || 'Field is required']"  label="Enter TAC" />
                    </div>
                    
                </div><div class="row justify-end" v-if="availableTrial < 3">
                    <div class="col-4 text-caption" style="color:red;">
                        Balance Trial :  {{availableTrial}}
                    </div>
                    
                </div>
                <div class="row justify-end q-pr-lg"   v-if="StoreStateT.showButton==true">
                    <div class="col-4 text-center">
                        <a href="#" @click="reTriggerTac()" class="text-primary">
                            Resend TAC
                        </a>
                    </div>
                </div>
                 
                <div class="row justify-end q-pr-lg q-pa-md" >
                    
                   <q-btn style="margin-right:10px;padding-left:10px;" @click="pushback()" color="red" label="Back" />
                    <Navigation 
                            v-if="StoreStateT.showButton2==true"
                            :ShowTACButton=true
                            ShowTACButtonColor="primary"
                            @ShowTAC="triggerTac()"
                        />
                            <Navigation 
                            v-if="StoreStateT.showButton==true"
                            :ShowSubmitButton=true
                            SubmitButtonColor="primary"
                            @SubmitButton="ConfirmTransaction()"
                        />
                </div>
        </q-card>
       
    </div>
</template>
<script>

import { mapActions } from 'vuex';
import store from '../../store';


import Navigation from '../../components/NavigationButtons'
export default {
      name: 'ApplicantDetails',
      components : {
          Navigation
    },
      data () {
		return {
            StoreStateT: store.state.Transactions,
            StoreStateAD : store.state.AD,            
            StoreStateLookup : store.state.Lookup,
			StoreStateAOD : store.state.AOD,
            tempMobileNo:'',
            showButton:false,
            availableTrial:3
        }
    },
	mounted () {
        this.StoreStateT.showButton2 =false
        this.StoreStateAD.TAC_code =''
    },
    computed: {},
    methods:{
        ...mapActions([
            "GetOnboardingSelf",
            "GetLookup",
           // "GeteMisLookup",
            "RequestTAC",
            "TACVerification",
            "TransactOnlineRedeemProcess",
            "PostTransaction_Submit_online",
            "getTranactionApplicationAPI",
            "getInvestorMobile"
        ]),
        pushback:function(){
            this.StoreStateAD.RedemptionStep='1'
        },
        reTriggerTac:function () {
            //0183790498
            this.StoreStateAOD.ContactInformation.MobileNo = '0183790498'
            //'0183790498'
            //'0149638728'
            this.formatMobileNo();
            var tempval = ''
           var vm = this
           //to do uncomment all this commented string
             this.RequestTAC({
                CustomerTelMobile : this.StoreStateAOD.ContactInformation.MobileNo,
                Purpose : 'I-Access Fund Transaction',
                CustomerId : this.StoreStateT.OnlineTransactionUserID,
                RIDType : ''
            })
            .then(res=>{
                if(res===true){ 
                    this.StoreStateT.showButton = true;
                 /*     this.$q.dialog({
                        title : 'Message',
                        message : 'Hey there TAC function is temporarily disabled. You may key in anything or just click Submit Button to continue'
                    }) */

                    this.$q.dialog({
                        title : 'Message',
                        message : 'A TAC has been sent to your mobile no ' + this.tempMobileNo 
                    })
                  
                 }
            }) 
        },
        triggerTac:function(){
             this.$q.loading.show({
                spinnerSize: 50,
            })
            this.getInvestorMobile().then(res=>{
                if(res === true){
                    
                    this.StoreStateAOD.ContactInformation.MobileNo = '0183790498'
                   // '0183790498'
                    
                    this.StoreStateT.showButton2 = false;
                    this.formatMobileNo();
                    var tempval = ''
                    var vm = this
                //    console.log("vm.StoreStateAOD.ContactInformation.MobileNo"+vm.StoreStateAOD.ContactInformation.MobileNo)
                 //   console.log("m.StoreStateT.OnlineTransactionUserID"+vm.StoreStateT.OnlineTransactionUserID)
              
                    //to do uncomment all this commented string
                            this.RequestTAC({
                                CustomerTelMobile : vm.StoreStateAOD.ContactInformation.MobileNo,
                                Purpose : 'I-Access Fund Transaction',
                                CustomerId : vm.StoreStateT.OnlineTransactionUserID,
                                RIDType : ''
                            })
                            .then(res=>{
                                if(res===true){ 

                                    

                                    vm.StoreStateT.showButton = true;
                                  /*   this.$q.dialog({
                                        title : 'Message',
                                        message : 'Hey there TAC function is temporarily disabled. You may key in anything or just click Submit Button to continue'
                                    }) */

                                   vm.$q.dialog({
                                        title : 'Message',
                                        message : 'A TAC has been sent to your mobile no ' + this.tempMobileNo 
                                    })
                                
                                }
                            }) 
                    vm.$q.loading.hide()
                }else{
                    this.$q.loading.hide()
                    this.$q.dialog({
                        title : 'Ooopss',
                        message : 'Unable to proceed. Cannot retrieve your mobile number from our database.'  
                    })
                }
            })
        },
        ConfirmTransaction:function(){
            //comment this before go prod 
            this.$q.loading.show({
                spinnerSize: 50,
            })
            if(this.availableTrial >0){
                this.TACVerification({
                    CustomerId : this.StoreStateT.OnlineTransactionUserID,
                    TAC: this.StoreStateAD.TAC_code,
                    Purpose: 'I-Access Fund Transaction'
                }).then(res=>{
                     /* if(res===false){
                        this.$q.dialog({
                            title : 'Message',
                            message : 'Error. Please retry.'  
                        })
                    }else  */
                   if( res === true){ 
                        ///here//
                                this.PostTransaction_Submit_online().then(res=>{
                                    if(res===true){
                                        this.$q.loading.hide()
                                        this.StoreStateAD.RedemptionStep='3' 
                                    
                                    }else{
                                        this.$q.loading.hide()
                                        this.$q.dialog({
                                            title : 'Error',
                                            message : res  
                                        })
                                    }  
                                })
                    ///here//
                    }else if(res=== false){
                        this.$q.loading.hide()
                        this.$q.dialog({
                            title : 'Error',
                            message : "TAC verification API down. Please resend TAC and verify new TAC"
                        })
                    }
                    else{
                        
                        this.availableTrial = this.availableTrial - 1 
                        this.$q.loading.hide()
                        this.$q.dialog({
                            title : 'Error',
                            message : res  
                        })
                    }
                })  
            }else{
                this.$q.loading.hide()
                this.$q.dialog({
                    title : 'Warning',
                    message : 'Sorry. It appears your TAC trial is maxed out. You require to restart your transaction'  
                })
            }
               
            ///            
        },
        Cancel:function(){
            alert('Completely out of application to login page')
        },
        formatMobileNo:function() {

        this.StoreStateAOD.ContactInformation.MobileNo = '0183790498'
        //'0183790498'
        var mobileNo = this.StoreStateAOD.ContactInformation.MobileNo       
        this.tempMobileNo =  '01x- xxxx ' + mobileNo.slice(-4) ;
      }
    }
}
</script>
<style lang="stylus">
.g_header
    padding-left: 35px
    padding-top: 50px
    padding-bottom: 10px
    font-size: 20px
    font-family: 'Cabin', sans-serif
    font-weight: 700

.g_text
    padding-left: 35px
    font-size: 15px
    font-family: 'Cabin', sans-serif
    font-weight: 300

.g_retry
    padding-left: 35px
    font-size: 15px
    font-family: 'Cabin', sans-serif
    font-weight: 150
</style>